
const REWARD_MIN = "REWARD_MIN"
const REWARD_PLUS = "REWARD_PLUS"
const REWARD = "reward"
const NON_REWARD = "nonreward"
const LIST_FILTER = "LIST_FILTER"
const MSG_ADD_ORDER = 
"Pesanan Anda sudah kami terima. " +
"Jumlah pesanan Anda akan kami sesuaikan dengan ketersediaan jumlah barang di gudang kami, " +
"kami memohon maaf sebelumnya apabila ketersediaan barang tidak sesuai jumlah pesanan, " +
"maka akan kami informasikan kembali. Terima Kasih."
const TOOLTIP_UPD_QTY = "Jumlah produk pesanan Anda telah disesuaikan dengan ketersediaan jumlah" +
" barang di gudang kami. Ketuk order Anda untuk detail lebih lanjut"
const TRX_TERSEDIA = "Tersedia"
const TRX_QUANTITY_TERUPDATE  = "Quantity Terupdate"
const TRX_TIDAK_TERSEDIA = "Tidak Tersedia"
const TRX_BELUM_TERSEDIA = "Belum Tersedia"
const DIST_SMA = "SMA"
const ERR_EXPIRED_TOKEN_MSG = 'Token sudah tidak bisa digunakan'
    
export default {
  REWARD_MIN: REWARD_MIN,
  REWARD_PLUS: REWARD_PLUS,
  REWARD: REWARD,
  NON_REWARD: NON_REWARD,
  LIST_FILTER: LIST_FILTER,
  MSG_ADD_ORDER: MSG_ADD_ORDER,
  TOOLTIP_UPD_QTY: TOOLTIP_UPD_QTY,
  TRX_TERSEDIA: TRX_TERSEDIA,
  TRX_QUANTITY_TERUPDATE: TRX_QUANTITY_TERUPDATE,
  TRX_TIDAK_TERSEDIA: TRX_TIDAK_TERSEDIA,
  TRX_BELUM_TERSEDIA: TRX_BELUM_TERSEDIA,
  DIST_SMA: DIST_SMA,
  ERR_EXPIRED_TOKEN_MSG:ERR_EXPIRED_TOKEN_MSG
}